module.exports = __webpack_public_path__ + "img/header_bg_vip.eb41e7a6.png";